import type { GenShotJob } from '@/types/editor';

/** Error text written by the old 5-minute client timeout (pre-webhook). */
export const LEGACY_CLIENT_TIMEOUT = 'Generation timed out after 5 minutes';

/**
 * A generation job that still needs its completion applied. Besides normal
 * `running` jobs, this recovers projects saved by the old 5-minute client
 * timeout: those jobs were still alive (and already charged) on the server, so
 * resuming the SAME job id is the only safe path — retrying would create a
 * second paid generation.
 *
 * Neutral module (no UI/store imports) so it can be shared by the poller, the
 * `applyCompletedGenJob` helper, and the SSE client without a layering cycle.
 */
export function isPollableGenerationJob(
  job: Pick<GenShotJob, 'state' | 'jobId' | 'error'>
): boolean {
  return Boolean(
    job.jobId &&
      (job.state === 'running' || (job.state === 'error' && job.error === LEGACY_CLIENT_TIMEOUT))
  );
}
